<div class="col-md-12">
  <div class="row-no-margin">
    <span class="popup-header">Order: {{order.OrderNumber}}</span>
  </div>
  <div class="row-no-margin">
    <span>{{order.DistributorName}} | {{order.CustomerNumber}}</span>
  </div>
  <div class="row-no-margin">
    <span>{{order.Status}}</span>
  </div>
  <div class="row-no-margin">
    <div class="col-md-2">
      <span class="popup-label">Order Date</span>
      <br />
      <span class="popup-value">{{order.OrderDate | date:'M/d/y'}}</span>
    </div>
    <div class="col-md-4">
      <span class="popup-label">PO #</span>
      <br />
      <span class="popup-value">{{order.PONumber}}</span>
    </div>
  </div>
  <div class="row-no-margin bottom-border" style="margin-top:10px;">
    <span class="popup-sub-header">General Information</span>
  </div>
  <div class="row-no-margin">
    <div class="col-md-4">
      <span class="popup-label">Config String</span>
      <br />
      <span class="popup-value">{{detail.ConfigString ?? detail.Description}}</span>
    </div>
    <div class="col-md-2">
      <span class="popup-label">Item</span>
      <br />
      <span class="popup-value">{{detail.Item}}</span>
    </div>
    <div style="display:none;" class="col-md-6">
      <span class="popup-label">Work Status Description</span>
      <br />
      <table style="width:100%;">
        <tr>
          <th>Description</th>
          <th style="text-align:center;">Quantity</th>
          <th style="text-align:center;">Complete</th>
        </tr>
        <ng-container *ngFor="let job of detail.Jobs">
          <ng-container *ngFor="let jobRoute of job.JobRoutes | sort :'JobOperation'">
            <tr>
              <td>{{jobRoute.Description}}</td>
              <td style="text-align:center;">{{jobRoute.QtyComplete}}</td>
              <td style="text-align:center;"><input type="checkbox" [checked]=jobRoute.Complete /></td>
            </tr>
          </ng-container>
        </ng-container>
      </table>
      <!--<span class="popup-value">{{jobRoute.Description}}:{{jobRoute.Complete ? "Complete" : "Pending"}}</span>-->
    </div>
    <!--<div class="col-md-3">
      <span class="popup-label">Work Status Description</span>
      <br />
      <span class="popup-value">{{detail.Item}}</span>
    </div>-->
  </div>
  <div class="row-no-margin bottom-border" style="margin-top:10px;">
    <span class="popup-sub-header">Shipping</span>
  </div>
  <div class="row-no-margin">

    <div class="col-md-3">
      <ng-container *ngIf="detail.Shipments.length == 0">
        <span class="popup-label">(Est) Ship Date</span>
      </ng-container>
      <ng-container *ngIf="detail.Shipments.length > 0">
        <span class="popup-label">Ship Date</span>
      </ng-container>
      <br />
      <ng-container *ngIf="detail.Shipments.length == 0">
        <span *ngIf="detail.EstShipDate.length > 0" class="popup-value">({{detail.EstShipDate  | date:'M/d/y'}})</span>
        <span *ngIf="detail.EstShipDate.length == 0" class="popup-value">{{detail.ShipDate | date:'M/d/y'}}</span>
      </ng-container>
      <ng-container *ngIf="detail.Shipments.length > 0">
        <ng-container *ngFor="let ship of detail.Shipments">
          <span (click)="DownloadShipmentPackingSlip(ship)" class="popup-value clickable blue-color">{{ship.ShipDate | date:'M/d/y'}}&nbsp;:&nbsp;{{ship.QtyShipped}} Shipped</span>
          <br />
        </ng-container>
      </ng-container>
    </div>
    <div class="col-md-3">
      <span class="popup-label">Customer</span>
      <br />
      <span class="popup-value">{{order.DistributorName}}</span>
    </div>
    <div class="col-md-3">
      <span class="popup-label">
        Address
      </span>
      <br />
      <span class="popup-value">{{order.ShipToStreet}}<br />{{order.ShipToCity}}, {{order.ShipToState}} {{order.ShipToZip}}<br />{{order.ShipToCountry}}</span>
    </div>
    <div class="col-md-2">
      <span class="popup-label">Ship To</span>
      <br />
      <span class="popup-value">{{order.ShipToName}}</span>
    </div>
  </div>
  <div>
    <div class="border-bottom">
      <span class="popup-sub-header">Documents</span>
    </div>
    <div class="row-no-margin">
      <ul>
        <li *ngIf="order.OrderVerificationPath.length > 0" style="list-style:none;padding:5px;"><span class="clickable blue-color" (click)="DownloadVerification()"><fa-icon [icon]="faFileLines" class="clickable blue-color"></fa-icon>&nbsp;Order Verification</span></li>
        <li *ngFor="let invoice of detail.Invoices" style="list-style:none;padding:5px;"><span class="clickable blue-color" (click)="DownloadInvoiceReport(invoice)"><fa-icon [icon]="faFileLines" class="clickable blue-color"></fa-icon>&nbsp;Invoice Report - {{invoice.InvoiceNumber}}</span></li>
        <li *ngFor="let ship of ShipmentIDList" style="list-style:none;padding:5px;"><span class="clickable blue-color" (click)="DownloadShipmentPackingSlipByID(ship)"><fa-icon [icon]="faFileLines" class="clickable blue-color"></fa-icon>&nbsp;Packing Slip - {{ship}}</span></li>
      </ul>
    </div>
  </div>
</div>
<div #spinnerModal id="spinnerModal" [hidden]="hideLoadingModal" style="width:100%;height:inherit;float:left;position:absolute;z-index:10000;display:block;left:0;top:0px;bottom:0px; background-color:#AAAAAA;opacity:0.4;">
  <div style="position: absolute; top: 45%; left: 45%;">
    <mat-spinner mode="indeterminate"></mat-spinner>
  </div>
</div>
